import request from '@/utils/request'

// 查询发货预测基础数据维护列表
export function apiListScpSopDfcBasicData (query) {
  return request({
    url: '/scp/scpSopDfcBasicData/list',
    method: 'get',
    params: query
  })
}

// 删除发货预测基础数据维护
export function apiDeleteScpSopDfcBasicData (ids) {
  return request({
    url: `/scp/scpSopDfcBasicData/${ids}`,
    method: 'delete'
  })
}

// 新增发货预测基础数据维护
export function apiScpSopDfcBasicData (data) {
    return request({
      url: '/scp/scpSopDfcBasicData',
      method: 'post',
      data: data
    })
  }
// 获取发货预测基础数据维护详细信息
export function apiScpSopDfcBasicDataDetail (id) {
    return request({
      url: `/scp/scpSopDfcBasicData/${id}`,
      method: 'get'
    })
  }
  // 查询期初发货比例列表
export function apiScpSopFcInitialDeliveryRatioList (query) {
  return request({
    url: `/scp/scpSopFcInitialDeliveryRatio/list`,
    method: 'get',
    params: query

  })
}
  // /修改期初发货比例
  export function apiScpSopFcInitialDeliveryRatio (data) {
    return request({
      url: `/scp/scpSopFcInitialDeliveryRatio`,
      method: 'put',
      data: data
    })
  }
  // 删除期初发货比例 scpSopFcInitialDeliveryRatio/{ids}
  export function apiDelScpSopFcInitialDeliveryRatio (id) {
    return request({
      url: `/scp/scpSopFcInitialDeliveryRatio/${id}`,
      method: 'delete'
    })
  }
  /**
   * 历史发货比例
   */
    // 查询历史发货比例列表
export function apiScpSopFcHistoricalDeliveryRatioList (query) {
  return request({
    url: `/scp/scpSopFcHistoricalDeliveryRatio/list`,
    method: 'get',
    params: query

  })
}
  // /修改期初发货比例
  export function apiScpSopFcHistoricalDeliveryRatio (data) {
    return request({
      url: `/scp/scpSopFcHistoricalDeliveryRatio`,
      method: 'put',
      data: data
    })
  }
  // 删除期初发货比例 scpSopFcInitialDeliveryRatio/{ids}
  export function apiDelScpSopFcHistoricalDeliveryRatio (id) {
    return request({
      url: `/scp/scpSopFcHistoricalDeliveryRatio/${id}`,
      method: 'delete'
    })
  }
/**
   * 滚动业绩报表
   */
    // 查询滚动业绩报表列表
    export function apiScpSopRollPsParametersList (query) {
      return request({
        url: `/scp/scpSopRollPsParameters/list`,
        method: 'get',
        params: query
      })
    }
      // /修改滚动业绩报表
      export function apiScpSopRollPsParameters (data) {
        return request({
          url: `/scp/scpSopRollPsParameters`,
          method: 'put',
          data: data
        })
      }
      // 删除滚动业绩报表 /scpSopRollPsParameters/{ids}
      export function apiDelScpSopRollPsParameters (id) {
        return request({
          url: `/scp/scpSopRollPsParameters/${id}`,
          method: 'delete'
        })
      }
